// extracted by mini-css-extract-plugin
export var component = "InlineList-module--component--oT-UX";